import styles from './cookie-drawer.module.css';

import { Box, Button, Card, Flex, Text } from '@radix-ui/themes';
import { createPortal } from 'react-dom';
import Link from 'next/link';
import {
  COOKIES_DESCRIPTION,
  COOKIES_TITLE,
  PRIVACY_POLICY
} from '@/app/lib/constants/messages';
import { BUTTON_NAMES } from '@/app/lib/constants/button-names';

interface Props {
  render: boolean;
  drawerPortal: HTMLElement | null;
  isOpen: boolean;
  onAccept: () => void;
}

export default function CookieDrawer({
  render,
  drawerPortal,
  isOpen,
  onAccept
}: Props) {
  return (
    <>
      {render &&
        drawerPortal &&
        createPortal(
          <div className={styles.Drawer}>
            <div
              className={`${styles.DrawerInner} ${isOpen ? styles.open : ''}`}
            >
              <Card className={styles.CookieDrawerContent}>
                <Box p='4'>
                  <Flex
                    direction='column'
                    width='100%'
                    gap='4'
                  >
                    <Text
                      as='div'
                      size='5'
                    >
                      {COOKIES_TITLE}
                    </Text>
                    <Text
                      as='div'
                      size='2'
                    >
                      {COOKIES_DESCRIPTION}{' '}
                      <Link
                        href='/privacy-policy'
                        className={styles.Link}
                      >
                        {PRIVACY_POLICY}
                      </Link>
                      .
                    </Text>
                    <Flex
                      justify={{ initial: 'center', sm: 'start' }}
                      px={{ initial: '4', sm: 'auto' }}
                      pb='4'
                    >
                      <Box
                        width={{ initial: '100%', sm: 'auto' }}
                        pt='4'
                      >
                        <Button
                          onClick={onAccept}
                          style={{ width: '100%' }}
                          autoFocus
                        >
                          {BUTTON_NAMES.good}
                        </Button>
                      </Box>
                    </Flex>
                  </Flex>
                </Box>
              </Card>
            </div>
          </div>,
          drawerPortal
        )}
    </>
  );
}
